import SlideManager from "./slide-manager";
import RenderManager from "../rendering/render-manager";
import { listen } from "./events";

function initTextureUsers() {
    listen("delete_texture", unassignTextureUsers);
    listen("replace_texture", reassignTextureUsers);
}

function unassignTextureUsers({ uuid }) {
    unassignMaterials(uuid);
    unassignBackgrounds(uuid);
}

function reassignTextureUsers({ uuid }) {
    reassignMaterials(uuid);
    reassignBackgrounds(uuid);
}

const MapTypes = ["", "alpha", "roughness", "metalness", "normal", "bump", "ao", "emissive"];
const unassignMap = {};

function unassignMaterials(mapUuid) {
    for (let matUuid in Q3.data.assets.materials) {
        const materialData = Q3.data.assets.materials[matUuid];
        const material = Q3.assets.materials[matUuid];

        for (let mapType of MapTypes) {
            const key = mapType + (mapType ? "Map" : "map");
            
            if (materialData[key] === mapUuid) {
                unassignMap[mapType](material, mapUuid);

                materialData[key] = null;
                material.needsUpdate = true;

                RenderManager.activeCamera.update = true;
            }
        }
    }
}

unassignMap[""] = (material, mapUuid) => material["map"] = null;
unassignMap["alpha"] = (material, mapUuid) => material["alphaMap"] = null;
unassignMap["roughness"] = (material, mapUuid) => material["roughnessMap"] = null;
unassignMap["metalness"] = (material, mapUuid) => material["metalnessMap"] = null;
unassignMap["normal"] = (material, mapUuid) => material["normalMap"] = null;
unassignMap["bump"] = (material, mapUuid) => material["bumpMap"] = null;
unassignMap["ao"] = (material, mapUuid) => material["aoMap"] = null;
unassignMap["emissive"] = (material, mapUuid) => material["emissiveMap"] = null;

function unassignBackgrounds(texUuid) {
    const isMobile = Q3.editMode ? Q3.mobileView : Q3.browserCapabilities.isMobile;

    for (let [i, slideData] of Q3.data.slides.entries()) {
        const oldBgValue = isMobile && slideData.background.value.image.textureMobile || slideData.background.value.image.texture;

        if (slideData.background.value.image.texture === texUuid)
            slideData.background.value.image.texture = null;

        if (slideData.background.value.image.textureMobile === texUuid)
            slideData.background.value.image.textureMobile = null;

        const newBgValue = isMobile && slideData.background.value.image.textureMobile || slideData.background.value.image.texture;

        if (i === SlideManager.activeSlide && oldBgValue !== newBgValue) {
            RenderManager.background.setBackground(slideData.background);
            RenderManager.activeCamera.update = true;
        }
    }
}

const reassignMap = {};

function reassignMaterials(uuid) {
    for (let matUuid in Q3.data.assets.materials) {
        const materialData = Q3.data.assets.materials[matUuid];
        const material = Q3.assets.materials[matUuid];

        for (let mapType of MapTypes) {
            const key = mapType + (mapType ? "Map" : "map");

            if (materialData[key] === uuid) {
                reassignMap[mapType](material, uuid);

                RenderManager.activeCamera.update = true;
            }
        }
    }
}

reassignMap[""] = (material, uuid) => material["map"] = Q3.assets.textures[uuid];

reassignMap["alpha"] = (material, uuid) => material["alphaMap"] = Q3.assets.textures[uuid];
reassignMap["roughness"] = (material, uuid) => material["roughnessMap"] = Q3.assets.textures[uuid];
reassignMap["metalness"] = (material, uuid) => material["metalnessMap"] = Q3.assets.textures[uuid];
reassignMap["normal"] = (material, uuid) => material["normalMap"] = Q3.assets.textures[uuid];

reassignMap["bump"] = (material, uuid) => material["bumpMap"] = Q3.assets.textures[uuid];

reassignMap["ao"] = (material, uuid) => material["aoMap"] = Q3.assets.textures[uuid];
reassignMap["emissive"] = (material, uuid) => material["emissiveMap"] = Q3.assets.textures[uuid];

function reassignBackgrounds(uuid) {
    const isMobile = Q3.editMode ? Q3.mobileView : Q3.browserCapabilities.isMobile;
    const slide = SlideManager.activeSlide;
    const slideData = Q3.data.slides[slide];
    const bgValue = isMobile && slideData.background.value.image.textureMobile || slideData.background.value.image.texture;

    if (bgValue === uuid) {
        const bg = RenderManager.background;

        bg.setBackground({
            type: slideData.backgroundType,
            value: bgValue,
            imageOffsetX: bg.offset.x,
            imageOffsetY: bg.offset.y,
            imageScaleX: bg.imgScale.x,
            imageScaleY: bg.imgScale.y
        });

        RenderManager.activeCamera.update = true;
    }
}

export default initTextureUsers;
export { initTextureUsers };
